import { Button } from '@material-ui/core'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Field } from 'redux-form'

import { renderColorPickerField, renderTextField } from '../../Forms/fieldRenderers'
import { CerealVariedadDropdown } from '../../Forms/SharedComponents/containers'
import DropdownEtiqueta from '../shared/dropDownEtiqueta/containers/DropdownEtiqueta'

const cerealToColor = (cereal) => {
  if (!cereal) return null
  switch (cereal.trim().toLowerCase()) {
    case ('soja'):
      return '#f44336' // red500
    case ('cebadace'):
      return '#2196f3'// blue500
    case ('cebadafo'):
      return '#4caf50'// green500
    case ('maiz'):
      return '#9c27b0'// purple500
    case ('trigo'):
      return '#ffc107'// amber500
    default:
      return '#2196f3'
  }
}

// const etiquetaToColor = (etiqueta) => {
//   if (!etiqueta) return null
//   const etiSplited = etiqueta.trim().split("-")
//   return etiSplited[etiSplited.length-1].trim()
// }
export class OperacionesInicioLlenadoSiloDialogView extends Component {
  render () {
    const {
      silo, cereal, isNewEtiqueta, setEtiquetaAsNew
    } = this.props
    return (
      <div>
        <Row>
          <Col md={12}>
            <h2>Inicio de llenado de {silo.nombreCorto}</h2>
          </Col>
        </Row>
        <CerealVariedadDropdown />
        <Row>
          <Col md={8}>
            {isNewEtiqueta && <Field
              name='newEtiqueta'
              label='Etiqueta'
              type='text'
              component={renderTextField}
              placeholder='Etiqueta'
            />}
            {!isNewEtiqueta && <DropdownEtiqueta />}

          </Col>
          <Col md={4}>
            {!isNewEtiqueta && <Button onClick={() => setEtiquetaAsNew(true)}>
              Nueva
              Etiqueta
            </Button>}
            {isNewEtiqueta && <Button onClick={() => setEtiquetaAsNew(false)}>
              Reusar
              Etiqueta
            </Button>}
          </Col>
        </Row>
        {isNewEtiqueta && <Row>
          <Col md={12}>
            <Field
              name='color'
              label='Color'
              type='text'
              component={renderColorPickerField}
              placeholder=''
              initColor={cerealToColor(cereal)}
            />
          </Col>
        </Row>}
      </div>
    )
  }
}
